export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";